import type { ReactNode } from 'react';

interface FormSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
}

/**
 * FormSection Component
 *
 * Wrapper for form sections with consistent styling.
 * Provides a card-like container with title and optional description.
 */
export function FormSection({
  title,
  description,
  children,
}: FormSectionProps) {
  return (
    <div className="card mb-6">
      <h2 className="text-xl font-semibold mb-4 text-text-dark">{title}</h2>
      {description && (
        <p className="text-sm text-text-secondary mb-4">{description}</p>
      )}
      <div className="space-y-4">{children}</div>
    </div>
  );
}
